import React, { useState } from 'react';
import styled from 'styled-components';

import Input from './Input';
import { TextField } from './styled';

import { themes, AppointmentPackage, AppointmentProduct, ValidPromo } from 'kb-shared';
import { showErrorToast, showSuccessToast } from '../../../utilities/notificationUtils';
import usePromo from '../../../hooks/usePromo';

const { colors } = themes;

const CodeContainer = styled.div`
  align-items: center;
  background: ${colors.KBBeige};
  display: flex;
  padding: 40px 30px 30px 30px;
`;

const InputContainer = styled.div`
  margin-right: 30px;
`;

const PromoTextField = styled(TextField)`
  max-width: 160px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border: 1px solid ${themes.colors.KBTwilightDark};
  border-radius: 18px;
  background: transparent;
  text-transform: uppercase;
  cursor: pointer;

  :hover,
  :focus {
    outline: none;
    background: ${themes.colors.KBWhite};
  }
`;

type Props = {
  onPromoApply: (validPromo: ValidPromo) => void;
  product: AppointmentPackage;
};

const PromoCodeEntry = (props: Props) => {
  const [code, setCode] = useState();
  const { onPromoApply, product } = props;
  const appointmentProduct = ({
    ...product,
    type: 'package'
  } as unknown) as AppointmentProduct;
  const { validatePromo } = usePromo(appointmentProduct);

  return (
    <CodeContainer>
      <InputContainer>
        <Input>
          <PromoTextField
            id="billing-promo"
            placeholder="Promo code"
            onChange={e => setCode(e.target.value)}
            value={code}
          />
        </Input>
      </InputContainer>
      <Button
        onClick={() => {
          validatePromo(code)
            .then(({ validPromo, error }) => {
              if (error) {
                return showErrorToast('Discount does not apply to this item.');
              }
              if (!validPromo) return;
              onPromoApply(validPromo);
              showSuccessToast('Promo code accepted.');
            })
            .catch(() => {
              showErrorToast('Discount does not apply to this item.');
            });
        }}
      >
        Apply
      </Button>
    </CodeContainer>
  );
};

export default PromoCodeEntry;
